import React, { useEffect, useRef } from 'react';

export default function VistaPreviaComponent({ContenidoHTML}){
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.write(ContenidoHTML);
    doc.close();
  }, []);

  return(
      <iframe
        ref={iframeRef}
        width={'100%'}
        style={{
          minHeight:'500px'
        }}
        title="Vista previa"
      />
  )
}